<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{ translations('navbar.return_management') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-consignment-return'>{{ translations('consignment.archive_consignment_return') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('consignment.consignment_return_details') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('consignment.arrival_date') }}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ returnInfo.arrived_at ? $invoiceTools.formatDate(returnInfo.arrived_at) : '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('consignment.arrival_date') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model='tempInfo.arrived_at' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('arrived_at',tempInfo.arrived_at,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('consignment.return_date') }}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ returnInfo.returned_at ? $invoiceTools.formatDate(returnInfo.returned_at) : '----------'}}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('consignment.return_date') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model='tempInfo.returned_at' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('returned_at',tempInfo.returned_at,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('consignment.organization_number') }}</th>
                <td>{{returnInfo.reference_number}}</td>
              </tr>
              <tr>
                <th>{{ translations('consignment.consignee') }}</th>
                <td>{{returnInfo.client_name}}</td>
              </tr>
              <tr>
                <th>{{ translations('consignment.remarks') }}</th>
                <td>
                    <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>{{ returnInfo.memo ? returnInfo.memo : '--------------' }}</button>
                    <div id='popover-info10' class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('consignment.remarks') }}</div>
                        <div class='popover-body popover-content'>
                            <textarea class="form-control" v-model="tempInfo.memo"></textarea>
                        </div>
                        <div class='popover-footer'>
                            <button type='submit' v-on:click="updateField('memo', tempInfo.memo, 'info10')" class='btn btn-sm btn-primary'>
                              {{ translations('common.update') }}</button>
                        </div>
                    </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('common.last_updated_by') }}</th>
                <td>{{returnInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{ translations('common.last_update_time') }}</th>
                <td>{{returnInfo.updated_at}}</td>
              </tr>
              <tr>
                <th class="is_processed">{{ translations('consignment.processing_status') }}</th>
                <td>
                  <button type="button" class="btn btn-primary btn-sm" v-if="Number(returnInfo.is_processed) === 0" v-on:click="clickIsProcessed()">
                    {{ translations('consignment.mark_processed') }}</button>
                  <button type="button" class="btn btn-primary btn-sm" v-else v-on:click="clickIsProcessed()">{{ translations('consignment.revert_unprocessed') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteReturn()" href='#'>{{ translations('common.delete') }}</a>
            </div>
          </div>
          <hr>
          <div>
            <h5 class='mb-3'>Check list</h5>
            <div class='padding-inline-start-5px'>
              <div>◎{{ translations('consignment.best_condition') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('consignment.sealed_item') }}</li>
                </ul>
              </div>
              <div>○{{ translations('consignment.good_condition') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('consignment.unopened_unused') }}</li>
                </ul>
              </div>
              <div>△{{ translations('consignment.usable') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('consignment.functional_item') }}</li>
                </ul>
              </div>
              <div>×{{ translations('consignment.not_usable') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('consignment.immovable_damaged') }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{ translations('common.tax_included') }}</div><!-- TAXSTATUS -->
            <div v-else>{{ translations('common.tax_excluded') }}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ translations('consignment.consigned_status') }}</th>
                  <th>{{ translations('consignment.return_warehouse') }}</th>
                  <th>{{ translations('consignment.reason_return') }}</th>
                  <th>{{ translations('consignment.operation_confirmation') }}</th>
                  <th>{{ translations('consignment.verification_results') }}</th>
                  <th>{{ translations('consignment.model_number') }}</th>
                  <th>{{ translations('consignment.tax_classification') }}</th><!-- TAXSTATUS -->
                  <th>{{ translations('consignment.number_item') }}</th>
                  <th class="width-50-px">{{ translations('consignment.unit_price') }}</th>
                  <th class="width-50-px"></th>
                  <th>{{ translations('consignment.original_unit_price') }}</th>
                  <th>{{ translations('consignment.summary') }}</th>
                  <th>{{ translations('consignment.unit_price_total') }}</th>
                  <th>{{ translations('consignment.total_liabilities') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in returnDetails'>
                  <tr v-if="Number(detail.set_status) !== 2" :key='i'>
                    <td>
                      <!-- 未処理のみ削除可能 -->
                      <button v-if="Number(detail.return_status_id) === 1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>

                    <td v-if="!Number(returnInfo.is_processed) && Number(detail.set_status) !== 1">
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-status' + i" data-placement='right'>
                        {{ (detail.return_status_id) ? getRetrunPropsById(return_statuses, detail.return_status_id, 'name') : '-------------' }}
                      </button>
                      <div :ref="'status' + i" :id="'popover-status' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('consignment.condition') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_status_id" class="custom-select">
                            <template  v-for="(status, i) in return_statuses">
                              <option :key="i" :value="status.id">{{ status.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeStatus(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>
                    <td v-else>{{ getRetrunPropsById(return_statuses, detail.return_status_id, 'name') }}</td>

                    <td v-if="detail.id">
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-arrived_warehouse' + i" data-placement='right'>
                        {{ detail.arrived_warehouse ? warehouseName(detail.arrived_warehouse.id) : '-------------' }}
                      </button>
                      <div :ref="'arrived_warehouse' + i" :id="'popover-arrived_warehouse' + i" class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('consignment.return_warehouse') }}</div>
                        <div class='popover-body popover-content'>
                          <input type='date' v-model='detail.arrived_at' class='form-control'>
                          <v-select :options="warehouses" label="name" value="id" v-model="tempDetails[i].arrived_warehouse"></v-select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeArrivedWarehouse(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>
                    <td v-else>-------------</td>

                    <td>
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-reason' + i" data-placement='right'>
                        {{ (detail.return_reason_id) ? getRetrunPropsById(return_reasons, detail.return_reason_id, 'name') : '-------------' }}
                      </button>
                      <div :ref="'reason' + i" :id="'popover-reason' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('consignment.reason_return') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_reason_id" class="custom-select">
                            <template v-for="(reason, i) in return_reasons">
                              <!-- 破棄済以外 -->
                              <option :key="i" :value="reason.id">{{ reason.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeReason(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>

                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info0000' + i"
                        data-placement='right'
                      >{{ (detail.return_state_id) ? getRetrunPropsById(return_states, detail.return_state_id, 'name') : '-------------' }}</button>
                      <div :ref="'info0000' + i" :id="'popover-info0000' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('consignment.operation_confirmation') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_state_id" class="custom-select">
                            <!-- <option selected value="">-</option> -->
                            <template  v-for="(state, i) in return_states">
                              <option :key="i" :value="state.id">{{ state.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeState(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-test_result' + i"
                        data-placement='right'
                        style="max-width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                        :title="getTextResult(detail)"
                      >{{getTextResult(detail)}}</button>
                      <div :ref="'popover-test_result' + i" :id="'popover-test_result' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('consignment.verification_results') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetails[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeTestResult(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>{{ (typeof detail.model === 'number') ? getRetrunPropsById(products, detail.model, 'model') : detail.model }}</td>

                    <td v-if="!Number(returnInfo.closing_flag)">
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangeTaxclass(detail)">
                        <option value="1">{{ translations('consignment.taxable_item') }}</option>
                        <option value="2">{{ translations('consignment.not_applicable') }}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td v-else>{{ detail.taxclass_id === 1 ? translations('consignment.taxable_item') : translations('consignment.not_applicable') }}</td>

                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>

                    <td v-if="!Number(returnInfo.closing_flag)">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @focus="refresh('unit_price')" @blur="refresh('unit_price')" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td v-else>{{ toTaxFormat(detail, 'unit_price') }}</td>

                    <td v-if="Number(detail.taxclass_id) === 1" class="right">({{ $util.getIncludeTax(detail.unit_price, detail.tax_rate).toLocaleString()}})</td>
                    <td v-else></td>

                    <td class="right">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'row_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.row_price" @focus="refresh('row_price')" @blur="refresh('row_price')" /><!-- 既存の class に number-input 追記 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.row_price && detail.row_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>

                    <td class="right">
                      <input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks" @change="onChangeRemarks(detail)"/>
                    </td>

                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ Number(detail.return_status_id) !== 8 ? toTaxFormat(detail, 'total_cost') : 0 }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReturnsModal'><i></i></button>
                  </td>
                  <td></td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <!-- 追加か削除された場合にのみ有効化 -->
              <button :disabled="!isAddOrDelete" @click="updateReturn()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" href="javascript:;" @click="openDeliverySlip()">{{ translations('consignment.print_consignment_return_slip') }}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewReturnsModal
      :returnDetails='returnDetails'
      :returnStatuses="return_statuses"
      :returnReasons="return_reasons"
      :returnStates="return_states"
      :products="products"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    /><!-- VAT -->
    <SingleReturnsModal :setItems="setItems" :return_id="returnId" :returnDetails='returnDetails'/>
    <SingleReturnMoveModal :isConsignment=true :warehouses="warehousesForModal" :warehouseId="tempInfo.warehouses_id" :detail="selectedDetail"/>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery' // number-container
import VueElementLoading from 'vue-element-loading'
import NewReturnsModal from '@/components/NewReturnsModal'
import SingleReturnsModal from '@/components/SingleReturnModal'
import SingleReturnMoveModal from '@/components/SingleReturnMoveModal'
import { mapState } from 'vuex'
export default {
  name: 'SingleConsignmentReturn',
  props: {},
  components: {
    VueElementLoading,
    NewReturnsModal,
    SingleReturnsModal,
    SingleReturnMoveModal
  },
  watch: {
    returnDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.tempDetails = JSON.parse(JSON.stringify(v))
        this.calcGrandTotals()
        // this.withSetItem()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      returnId: '',
      isLoading: false,
      returnInfo: {},
      returnDetails: [],
      tempInfo: {},
      tempDetails: [],
      originalInfo: {},
      originalDetails: [],
      warehousesForModal: [],
      destinations: [],
      delivery_destinations: [],
      products: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      setItems: [],
      selectedDetail: null,
      clickAddDetail: false,
      deliveryFile: null
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    processType: function () {
      const self = this
      return function (detail) {
        if (self.returnInfo.bill_to_id && self.returnInfo.bill_to_id.id === -1) return 'move' // -1:自社移動, -2:お客様交換用（不良品破棄）

        let action = ''
        switch (detail.return_status_id) {
          case self.$const['RETURN_PROCESS_新品']:
          case self.$const['RETURN_PROCESS_相殺済み']:
          case self.$const['RETURN_PROCESS_代替済み']:
            action = 'move'
            break
          case self.$const['RETURN_PROCESS_破棄待ち']:
            action = 'discard'
            break
        }
        return action
      }
    },
    warehouseName: function () {
      const self = this
      return function (warehouseId) {
        const warehouse = self.warehouses.find((item) => item.id === Number(warehouseId))
        return warehouse ? warehouse.name : '不明な倉庫'
      }
    },
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_statuses () {
      const statuses = this.$store.getters['Replacement/getStatuses']
      return this.translateStatuses(statuses)
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    isAddOrDelete () {
      return JSON.stringify(this.returnInfo) !== JSON.stringify(this.originalInfo) || JSON.stringify(this.returnDetails.map(detail => detail.id)) !== JSON.stringify(this.originalDetails.map(detail => detail.id))
    },
    hasSetItem () {
      return this.returnDetails.filter(detail => detail.set_status === 1).length > 0
    }
  },
  created () {
    if (!this.$route.query.return_id) {
      this.$router.replace('archive-return')
      return
    }

    this.returnId = this.$route.query.return_id

    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Replacement/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkBillTo')
    this.$store.dispatch('Master/checkMywarehouses')

    this.getReturnDetails().catch(error => {
      this.$toastr.error(error.message, 'エラー')
    }).finally(() => {
      this.popoverButtons()
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    getReturnDetails () {
      this.isLoading = true
      return this.$http.post(this.$api_url.consignment_return_details, { return_id: this.returnId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.returnInfo = result.information
          this.returnDetails = result.details
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate

          this.tempInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.tempDetails = JSON.parse(JSON.stringify(this.returnDetails))

          this.originalInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.originalDetails = JSON.parse(JSON.stringify(this.returnDetails))
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SingleConsignmentReturn:getReturnDetails:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      data.arrived_warehouse = this.warehouses.find(item => item.id === Number(data.arrived_warehouse_id))

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.returnDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        if (v.return_status_id === 1) {
          this.grandTotalDebt += Number(v.total_cost)
        }
      })

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.returnDetails[index][target] = this.returnDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    openAddDetailModal () {
      this.getProducts()
    },

    setEmptyData () {
      this.returnInfo = {}
      this.returnDetails = []
      this.tempInfo = {}
      this.tempDetails = []
      this.warehouses = []
      this.warehousesForModal = []
      this.bill_to = []
      this.destinations = []
      this.delivery_destinations = []
      this.products = []
    },

    isNewReturn () {
      return this.$route.name === 'new-consignment-return'
    },

    async getBoundProduct () {
      try {
        const response = await this.$http.post(this.$api_url.consignment_return_bound_product, { return_id: this.returnId })
        const result = response.data
        if (result.status === true) {
          this.setItems = result.list
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      } catch (error) {
        console.log('SingleConsignmentReturn:getBoundProduct:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    setReturnDate () {
      // 今日の日付データを変数hidukeに格納
      const hiduke = new Date()

      // 年・月・日・曜日を取得する
      const year = hiduke.getFullYear()
      const month = hiduke.getMonth() + 1
      const day = hiduke.getDate()

      const dateAt = year + '-' + month + '-' + day
      this.$refs.info01.innerText = year + '/' + month + '/' + day
      this.returnInfo.returned_at = dateAt
      this.tempInfo.returned_at = dateAt
    },

    async openDeliverySlip () {
      if (!this.deliveryFile) {
        try {
          const response = await this.$http.post(this.$api_url.consignment_return_delivery_slip, { return_id: this.returnId })
          const result = response.data
          if (result.status === true && result.slip) {
            this.deliveryFile = result.slip
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
        } catch (error) {
          console.log('SingleConsignmentReturn:openDeliverySlip:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      }

      if (this.deliveryFile) {
        let arrBuff = this.__b64ToArrayBuffer(this.deliveryFile.replace('data:application/pdf;base64,', ''))
        const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
        const deliveryFileURL = URL.createObjectURL(deliveryFile)
        window.open(deliveryFileURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    getTextResult (detail) {
      return detail.test_result ? detail.test_result : '-------------'
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let val = ''
      const rg = /^\s+$/
      if (
        !value ||
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '----------'
        val = ''
      } else if (field === 'returned_at') {
        const x = /-/gi
        this.$refs[ref].innerText = value.replace(x, '/')
        val = value
      } else if (field === 'arrived_at') {
        const x = /-/gi
        this.$refs[ref].innerText = value.replace(x, '/')
        val = value
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.returnInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    moveWarehouse (value) {
      this.selectedDetail = value
      window.$('#SingleReturnMoveModal').modal('show')
    },

    deleteDetail (i) {
      this.returnDetails.splice(i, 1)
    },

    async getProducts () {
      this.isLoading = true
      try {
        const params = {
          bill_to_id: 0, // すべての製品を取得
          arrived_at: this.tempInfo.arrived_at
        }

        const products = await this.$http.post(this.$api_url.return_product_list, params)
        const $data = this.$invoiceTools.prepareResult(products.data, 'list', 'SingleConsignmentReturn:getProducts')
        if ($data.success === true) {
          this.products = $data.data
          this.$refs.openAddDetailModal.click() // 成功時にモーダル表示
        } else {
          this.$toastr.error($data.data, '処理失敗')
        }
      } catch (error) {
        console.log('SingleConsignmentReturn:getProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      } finally {
        this.isLoading = false
      }
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },
    getRetrunPropsByItemNo (selection, itemNo, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.item_no === itemNo) {
          ret = val[name]
        }
      })
      return ret
    },

    async updateReturn () {
      try {
        if (!this.tempInfo.returned_at) {
          this.$toastr.warning('返品日を入力してください。')
          return
        }

        if (this.returnDetails.length < 1) {
          this.$toastr.warning('詳細行を入力してください。')
          return
        }

        this.isLoading = true
        let paramUpdate = {
          return_id: this.returnId,
          information: this.returnInfo,
          details: this.returnDetails
        }
        let updateReturn = await this.$http.post(this.$api_url.consignment_return_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateReturn.data, 'list', 'SingleConsignmentReturn:updateReturn')
        if ($data.success === true) {
          this.$toastr.success('保存に成功しました。', 'Success')
          this.getReturnDetails()
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        setTimeout(() => { this.isLoading = false }, 1000)
      } catch (error) {
        console.log('SingleConsignmentReturn:updateReturn:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async deleteReturn () {
      try {
        this.isLoading = true
        let deleteReturn = await this.$http.post(this.$api_url.consignment_return_delete, { return_id: this.returnId })
        let $data = this.$invoiceTools.prepareResult(deleteReturn.data, '', 'SingleConsignmentReturn:deleteReturn')
        if ($data.success === true) {
          this.$toastr.success('保存に成功しました。', 'Success')
          this.$router.replace({ name: 'archive-consignment-return' })
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        setTimeout(() => { this.isLoading = false }, 1000)
      } catch (error) {
        console.log('SingleConsignmentReturn:deleteReturn:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    // withSetItem () {
    //   let ret = 0
    //   this.returnDetails.forEach(val => {
    //     if (val.is_set === 1) {
    //       ret += 1
    //     }
    //   })
    //   if (ret) {
    //     this.getBoundProduct()
    //     return true
    //   }
    //   return false
    // },

    onChangeStatus (detail, i) {
      this.updateField('return_status_id', this.tempDetails[i].return_status_id, ('status' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        return_status_id: detail.return_status_id
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_status, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('状態を更新しました', 'Success')
          detail.return_status_id = response.data.return_status_id
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.return_status_id = response.data.old_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeState (detail, i) {
      this.updateField('return_state_id', this.tempDetails[i].return_state_id, ('info0000' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        return_state_id: detail.return_state_id
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_state, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('動作確認結果を更新しました', 'Success')
          detail.return_state_id = response.data.return_state_id
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.return_state_id = response.data.old_return_state_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeReason (detail, i) {
      this.updateField('return_reason_id', this.tempDetails[i].return_reason_id, ('reason' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        return_reason_id: detail.return_reason_id
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_reason, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('返品理由を更新しました', 'Success')
          detail.return_reason_id = response.data.return_reason_id
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.return_reason_id = response.data.old_return_reason_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeTestResult (detail, i) {
      this.updateField('test_result', this.tempDetails[i].test_result, ('test_result' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        test_result: detail.test_result
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_test_result, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('検証結果を更新しました', 'Success')
          detail.test_result = response.data.test_result
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.test_result = response.data.old_test_result
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeTaxclass (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        taxclass_id: detail.taxclass_id
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_taxclass, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('税区分を更新しました', 'Success')
          detail.taxclass_id = response.data.taxclass_id
        } else {
          self.$toastr.error(response.data.message, '更新に失敗しました')
          detail.taxclass_id = response.data.old_taxclass_id
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    onChangeUnitPrice (detail) {
      if (!detail.id) {
        if (!detail.taxclass_id) detail.taxclass_id = 1
        if (Number(detail.taxclass_id) === 1) { // 税区分（1:課税対象, 2:対象外）
          detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, detail.tax_rate)
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
        return
      }

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        selling_price: detail.unit_price,
        selling_price_inctax: Number(detail.taxclass_id) === 1 ? this.$util.getIncludeTax(detail.unit_price, detail.tax_rate) : detail.unit_price
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_selling_price, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('単価を更新しました', 'Success')
          detail.unit_price = response.data.selling_price
          detail.unit_price_inctax = response.data.selling_price_inctax
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.unit_price = response.data.old_selling_price
          detail.unit_price_inctax = response.data.old_selling_price_inctax
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    // onChangeQuantity (detail) {
    //   this.isLoading = true
    //   const params = {
    //     return_detail_id: detail.id,
    //     quantity: detail.quantity
    //   }
    //   const self = this
    //   this.$http.post(this.$api_url.consignment_return_change_quantity, params).then(function (response) {
    //     if (response.data.status) {
    //       self.$toastr.success('処理成功', 'Success')
    //       detail.quantity = response.data.quantity
    //     } else {
    //       self.$toastr.error(response.data.message, '処理失敗')
    //       detail.quantity = response.data.old_quantity
    //     }
    //   }).finally(function () {
    //     self.isLoading = false
    //   })
    // },
    onChangeRemarks (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        remarks: detail.remarks
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_remarks, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('摘要を更新しました', 'Success')
          detail.remarks = response.data.remarks
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.remarks = response.data.old_remarks
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    clickIsProcessed () {
      this.isLoading = true
      const params = {
        return_id: this.returnId,
        is_processed: Number(this.returnInfo.is_processed) === 0 ? 1 : 0
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_update_is_processed, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('処理状態を更新しました', 'Success')
          self.getReturnDetails()
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          self.returnInfo.is_processed = response.data.old_is_processed
          self.originalInfo.is_processed = response.data.old_is_processed
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    onChangeArrivedWarehouse (detail, i) {
      const oldWarehouse = detail.arrived_warehouse ? JSON.parse(JSON.stringify(detail.arrived_warehouse)) : null
      this.updateField('arrived_warehouse', this.tempDetails[i].arrived_warehouse, ('arrived_warehouse' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        client_id: this.returnInfo.client_id,
        return_detail_id: detail.id,
        arrived_warehouse_id: detail.arrived_warehouse ? detail.arrived_warehouse.id : null,
        arrived_at: detail.arrived_at
      }
      const self = this
      this.$http.post(this.$api_url.consignment_return_change_arrived_warehouse, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('返品先倉庫を更新しました', 'Success')
          detail.arrived_warehouse = self.warehouses.find(item => item.id === Number(response.data.arrived_warehouse_id))
          detail.arrived_at = response.data.arrived_at
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.arrived_warehouse = oldWarehouse
          detail.arrived_at = response.data.old_arrived_at
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    }
  }
}
</script>

<style>
#set-item-list{
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
}
</style>
